import { z } from 'zod';

/**
 * The admin area's period in the URL, the same three optional params on every admin route that shows a
 * period: `?period=30d`, or `?from=2026-09-01&until=2026-09-30` for a custom span. Spread into the
 * route's own schema. A value that is not one never fails the route: it is dropped, and the page falls
 * back to the remembered choice or its default (`parsePeriod`).
 */
export const periodSearch = {
  period: z.string().max(12).optional().catch(undefined),
  from: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  until: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
};
